import { ApplicationSubmitScreen } from "@/interactors/ApplicationSubmitScreen";

export default function Submit() {
  return <ApplicationSubmitScreen />;
}
